import { AppRouter } from './routes/AppRouter';
import './lib/i18n';

/**
 * Root component. Routing + i18n + theme are wired in main.tsx; this
 * component is intentionally tiny so each feature page renders flush
 * against the document body (no global chrome wrapper). Bottom-nav
 * and tab shells are scoped to the tab routes inside AppRouter.
 */
export default function App() {
  return <AppRouter />;
}
